<template>
  <ul class="card__list">
    <CourseCard v-for="(card, cardIndex) in cards" :content="card" :key="cardIndex" />
    <li class="card">{{ soon }}</li>
  </ul>
</template>

<script>
import CourseCard from '@/components/cards/CourseCard.vue'

export default {
  name: 'CourseCards',
  components: {
    CourseCard,
  },
  props: {
    cards: {
      type: Array,
      required: true,
    },
  },
  computed: {
    soon() {
      return this.$beet.isReady ? this.$beet.options.general.soon : ''
    },
  },
}
</script>
